import React, { useState, useEffect } from 'react'
import { Modal, Descriptions, Tag } from 'antd'
import { useGetClassesDiscountCodeById } from 'api/Classes/Step6Tickets/Tickets'
import ButtonSpinner from 'components/global/ButtonSpinner'
import dayjs from 'dayjs'

interface ViewDiscountProps {
  openModal: boolean
  closeModal: (value: boolean) => void
  id: string
}

const ViewDiscount: React.FC<ViewDiscountProps> = ({
  openModal,
  closeModal,
  id,
}) => {
  const [discountData, setDiscountData] = useState<any>(null)
  
  const {
    data: discountDetails,
    isLoading,
    refetch,
  } = useGetClassesDiscountCodeById(id)

  useEffect(() => {
    if (openModal && id) {
      refetch()
    }
  }, [openModal, id])

  useEffect(() => {
    if (discountDetails) {
      setDiscountData(discountDetails)
    }
  }, [discountDetails])

  return (
    <Modal
      title="Discount Details"
      open={openModal}
      onCancel={() => closeModal(false)}
      footer={null}
      width={600}
    >
      {isLoading ? (
        <div className="w-full py-30px flex justify-center align-center">
          <ButtonSpinner size={30} color="#2ba7ca" />
        </div>
      ) : discountData ? (
        <Descriptions column={1} bordered>
          <Descriptions.Item label="Discount Code">
            <Tag color="blue">{discountData.code}</Tag>
          </Descriptions.Item>
          
          <Descriptions.Item label="Discount Value">
            {discountData.discount}
            {discountData.type === 'percent' ? '%' : '$'}
          </Descriptions.Item>
          
          <Descriptions.Item label="Type">
            {discountData.type === 'percent' ? 'Percentage' : 'Fixed Amount'}
          </Descriptions.Item>
          
          <Descriptions.Item label="Status">
            <Tag color={discountData.status === 'active' ? 'green' : 'red'}>
              {discountData.status === 'active' ? 'Active' : 'Disabled'}
            </Tag>
          </Descriptions.Item>
          
          <Descriptions.Item label="Usage">
            {discountData.userIds?.length || 0} /{' '}
            {discountData.totalLimit || 'Unlimited'}
          </Descriptions.Item>
          
          {discountData.validFrom && (
            <Descriptions.Item label="Valid From">
              {dayjs(discountData.validFrom).format('MMMM D, YYYY')}
            </Descriptions.Item>
          )}
          
          {discountData.validTo && (
            <Descriptions.Item label="Valid To">
              {dayjs(discountData.validTo).format('MMMM D, YYYY')}
            </Descriptions.Item>
          )}
          
          <Descriptions.Item label="Created At">
            {dayjs(discountData.createdAt).format('MMMM D, YYYY HH:mm')}
          </Descriptions.Item>
          
          {discountData.admissionTickets && discountData.admissionTickets.length > 0 && (
            <Descriptions.Item label="Applicable Admission Tickets">
              {discountData.admissionTickets.map((ticket: any) => (
                <Tag key={ticket._id} color="blue" style={{ marginBottom: '4px' }}>
                  {ticket.name}
                </Tag>
              ))}
            </Descriptions.Item>
          )}
          
          {discountData.additionalOptions && discountData.additionalOptions.length > 0 && (
            <Descriptions.Item label="Applicable Additional Options">
              {discountData.additionalOptions.map((option: any) => (
                <Tag key={option._id} color="green" style={{ marginBottom: '4px' }}>
                  {option.name}
                </Tag>
              ))}
            </Descriptions.Item>
          )}
        </Descriptions>
      ) : (
        <div className="w-full py-30px flex justify-center align-center">
          <p>No discount data found</p>
        </div>
      )}
    </Modal>
  )
}

export default ViewDiscount
